import dayjs from 'dayjs';
export var getCurrentDate = function getCurrentDate() {
  return dayjs().startOf('day').format();
};